import React from 'react';
import {useSearchParams} from 'react-router-dom';

import {NAVIGATIONS} from '../Page.Projects.Update';

interface ISidebarRightProps {}

const SidebarRight = ({}: ISidebarRightProps) => {
  const [searchParams] = useSearchParams();
  const nav = searchParams.get('nav');
  return (
    <section className="w-70 shrink-0 overflow-y-auto border-l border-gray-200 dark:border-gray-800 bg-white dark:bg-darkBg p-2 lg:p-3">
      {(() => {
        const Component = nav ? NAVIGATIONS[nav as keyof typeof NAVIGATIONS]?.compRight : Object.values(NAVIGATIONS)[0].compRight;
        return Component ? <Component /> : null;
      })()}
    </section>
  );
};

export default React.memo(SidebarRight);
